import React from "react";
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {RequestState} from "@pg-mono/request-state";
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {ApplicationMultiLeadFormOfferBoxBase} from "./ApplicationMultiLeadFormOfferBoxBase";

interface IProps {
    offerAddress: string;
    offerMainImg?: string;
    offerType: OfferType;
    rooms?: number;
    area?: number;
    estimatedPriceInfoText: string | null;
    regionEstimatedPriceRequestState: RequestState;
    className?: string;
}

export const ApplicationMultiLeadOfferRevealedPriceBox = (props: IProps) => {
    const displayType = getOfferTypeNameCapital(props.offerType);

    return (
        <ApplicationMultiLeadFormOfferBoxBase
            title={`${displayType}, ${props.rooms ? `${props.rooms} ${roomsPluralize(props.rooms)}, ` : ""}${props.area ? areaFormat(props.area) : ""}`}
            address={props.offerAddress}
            imgSrc={props.offerMainImg}
            content={
                <>
                    {props.regionEstimatedPriceRequestState === RequestState.Waiting ? (
                        <Loader size="sm" />
                    ) : (
                        !!props.estimatedPriceInfoText && (
                            <Text variant="body_copy_2" className={revealedPriceBoxStyle}>
                                {props.estimatedPriceInfoText}
                            </Text>
                        )
                    )}

                    <Badge variant="label_success" className={successBadgeStyle} as="span">
                        <strong className={strongContentStyle}>
                            <div className={iconWrapperStyle}>
                                <InfoIcon size="1.6" />
                            </div>
                            Wysłano zapytanie
                        </strong>
                    </Badge>
                </>
            }
            coverClassName={coverStyle}
            className={cx(boxWrapperStyle, props.className)}
        />
    );
};

const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

const boxWrapperStyle = css({
    position: "relative",
    marginRight: "2.7rem",
    border: "1px solid var(--colors-gray-500)",
    transition: "all 0.2s ease-in-out",
    md: {
        marginRight: 0
    }
});

const coverStyle = css({
    flex: "0 0 99px",
    "& img": {
        width: "99px"
    },
    md: {
        flex: "0 0 123px",
        "& img": {
            width: "123px"
        }
    }
});

const revealedPriceBoxStyle = css({
    py: 0.5,
    px: 1,
    marginBottom: 1.5,
    color: "#000",
    backgroundColor: "var(--colors-primary)",
    width: "fit-content"
});

const successBadgeStyle = css({
    py: 0.5,
    px: 2,
    width: "fit-content"
});

const strongContentStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row"
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 1
});
import React from "react";
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {RequestState} from "@pg-mono/request-state";
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../../offer/helpers/OfferType";
import {OfferType} from "../../../offer/types/OfferType";
import {ApplicationMultiLeadFormOfferBoxBase} from "./ApplicationMultiLeadFormOfferBoxBase";

interface IProps {
    offerAddress: string;
    offerMainImg?: string;
    offerType: OfferType;
    rooms?: number;
    area?: number;
    estimatedPriceInfoText: string | null;
    regionEstimatedPriceRequestState: RequestState;
    className?: string;
}

export const ApplicationMultiLeadOfferRevealedPriceBox = (props: IProps) => {
    const displayType = getOfferTypeNameCapital(props.offerType);

    return (
        <ApplicationMultiLeadFormOfferBoxBase
            title={`${displayType}, ${props.rooms ? `${props.rooms} ${roomsPluralize(props.rooms)}, ` : ""}${props.area ? areaFormat(props.area) : ""}`}
            address={props.offerAddress}
            imgSrc={props.offerMainImg}
            content={
                <>
                    {props.regionEstimatedPriceRequestState === RequestState.Waiting ? (
                        <Loader size="sm" />
                    ) : (
                        !!props.estimatedPriceInfoText && (
                            <Text variant="body_copy_2" className={revealedPriceBoxStyle}>
                                {props.estimatedPriceInfoText}
                            </Text>
                        )
                    )}

                    <Badge variant="label_success" className={successBadgeStyle} as="span">
                        <strong className={strongContentStyle}>
                            <div className={iconWrapperStyle}>
                                <InfoIcon size="1.6" />
                            </div>
                            Wysłano zapytanie
                        </strong>
                    </Badge>
                </>
            }
            coverClassName={coverStyle}
            className={cx(boxWrapperStyle, props.className)}
        />
    );
};

const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

const boxWrapperStyle = css({
    position: "relative",
    marginRight: "2.7rem",
    border: "1px solid var(--colors-gray-500)",
    transition: "all 0.2s ease-in-out",
    md: {
        marginRight: 0
    }
});

const coverStyle = css({
    flex: "0 0 99px",
    "& img": {
        width: "99px"
    },
    md: {
        flex: "0 0 123px",
        "& img": {
            width: "123px"
        }
    }
});

const revealedPriceBoxStyle = css({
    py: 0.5,
    px: 1,
    marginBottom: 1.5,
    color: "#000",
    backgroundColor: "var(--colors-primary)",
    width: "fit-content"
});

const successBadgeStyle = css({
    py: 0.5,
    px: 2,
    width: "fit-content"
});

const strongContentStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row"
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 1
});
